import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Layer, Box, Button, Text } from 'grommet';
import { FormClose } from 'grommet-icons';

import { Placeholder } from '../../../../components';
import { SimpleDetail, Hr, Description, TitleDetail } from '../../../../components/detail';

import { formattedDateTime, formattedCurrency } from '../../../../utils';
import visibleWidth from '../../../../constants/layer-width';

import { toggleDetailsLayer } from '../../actions/details';

import { amendmentResources } from '../../../../constants/amendment-resources';

class DetailsAmendment extends Component {
  render() {
    const {
      detail,
      getDetailError,
      toggleLayer,

      toggleDetailsLayer,
    } = this.props;

    if(!toggleLayer || toggleLayer !== 'details') {
      return null;
    }

    return (
      <ResponsiveContext.Consumer>
        {size => (
          <Layer
            responsive={false}
            full='vertical'
            position='left'
            onClickOutside={toggleDetailsLayer}
            onEsc={toggleDetailsLayer}
          >
            <Box
              fill='vertical'
              width={visibleWidth[size]}
              pad={{
                top: size === 'small' ? 'xlarge' : 'large',
                bottom: size === 'small' ? 'large' : null,
              }}
              overflow='auto'
              flex
            >
              {getDetailError ? (
                <Placeholder
                  title='Ops! Algo deu errado :('
                  message='Estamos constrangidos por isso.'
                  button={{
                    label: 'Fechar',
                    action: toggleDetailsLayer,
                  }}
                />
              ) : null}

              {!detail && !getDetailError ? (
                <Placeholder
                  title='Carregando...'
                  message='Aguarde que estamos preparando as coisas :)'
                />
              ) : null}

              {detail ? (
                <>
                  <Box
                    direction='row'
                    justify='between'
                    align='baseline'
                    margin={{ horizontal: 'large' }}
                  >
                    <TitleDetail value='Detalhes da emenda' />

                    <Button
                      plain
                      title='Fechar'
                      icon={<FormClose />}
                      onClick={toggleDetailsLayer}
                    />
                  </Box>



                  <Box flex overflow='auto'>
                    <SimpleDetail
                      title='Origem do recurso'
                      value={amendmentResources[detail.resourceOrigin]}
                    />

                    {detail.secretaryId > 0 && <SimpleDetail
                      title='Secretaria'
                      value={detail.secretaryName}
                    />}

                    {detail.stageId > 0 && <SimpleDetail
                      title='Estágio'
                      value={detail.stageName}
                    />}

                    <Hr />

                    <SimpleDetail
                      title='Objeto'
                      value={detail.object}
                    />

                    <SimpleDetail
                      title='Ano'
                      value={detail.year}
                    />

                    <SimpleDetail
                      title='Valor'
                      value={formattedCurrency(detail.value)}
                    />

                    {detail.paymentDate && <SimpleDetail
                      title='Data de pagamento'
                      value={formattedDateTime(detail.paymentDate)}
                    />}

                    <Hr />

                    {detail.observation &&
                      <Description
                        title='Observações'
                        value={detail.observation}
                      />
                    }


                    {detail.requesters && detail.requesters.length > 0 &&
                      <>
                        <Hr />

                        <Box
                          margin={{
                            top: 'xsmall',
                            bottom: 'none',
                            horizontal: 'large',
                          }}
                          pad={{ bottom: 'small' }}
                          flex={{ shrink: 0 }}
                        >
                          <Text size='medium' color='dark-2' margin={{ bottom: 'medium' }}>
                            Solicitante(s)
                          </Text>

                          <Box
                            direction='row'
                            gap='small'
                            wrap={true}
                          >
                            {
                              detail.requesters.map((item) => (
                                <Box
                                  key={item.id}
                                  gap='small'
                                  round='large'
                                  pad={{ vertical: 'small', horizontal: 'medium' }}
                                  margin={{ bottom: 'small' }}
                                  border={{ color: 'light-3' }}
                                >
                                  <Box direction='row' align='center' gap='small'>
                                    <Text size='small' color='dark-2' >{item.name}</Text>
                                  </Box>
                                </Box>
                              ))
                            }
                          </Box>
                        </Box>
                      </>
                    }

                    {detail.beneficiaries && detail.beneficiaries.length > 0 &&
                      <>
                        <Hr />

                        <Box
                          margin={{
                            top: 'xsmall',
                            bottom: 'none',
                            horizontal: 'large',
                          }}
                          pad={{ bottom: 'small' }}
                          flex={{ shrink: 0 }}
                        >
                          <Text size='medium' color='dark-2' margin={{ bottom: 'medium' }}>
                            Beneficiário(s)
                          </Text>

                          <Box
                            direction='row'
                            gap='small'
                            wrap={true}
                          >
                            {
                              detail.beneficiaries.map((item) => (
                                <Box
                                  key={item.id}
                                  gap='small'
                                  round='large'
                                  pad={{ vertical: 'small', horizontal: 'medium' }}
                                  margin={{ bottom: 'small' }}
                                  border={{ color: 'light-3' }}
                                >
                                  <Box direction='row' align='center' gap='small'>
                                    <Text size='small' color='dark-2' >{item.name}</Text>
                                  </Box>
                                </Box>
                              ))
                            }
                          </Box>
                        </Box>
                      </>
                    }

                    {detail.regions && detail.regions.length > 0 &&
                      <>
                        <Hr />

                        <Box
                          margin={{
                            top: 'xsmall',
                            bottom: 'none',
                            horizontal: 'large',
                          }}
                          pad={{ bottom: 'small' }}
                          flex={{ shrink: 0 }}
                        >
                          <Text size='medium' color='dark-2' margin={{ bottom: 'medium' }}>
                            Cidade(s)
                          </Text>

                          <Box
                            direction='row'
                            gap='small'
                            wrap={true}
                          >
                            {
                              detail.regions.map(({ id, city, stateAbbrev }) => (
                                <Box
                                  key={id}
                                  gap='small'
                                  round='large'
                                  pad={{ vertical: 'small', horizontal: 'medium' }}
                                  margin={{ bottom: 'small' }}
                                  border={{ color: 'light-3' }}
                                >
                                  <Box direction='row' align='center' gap='small'>
                                    <Text size='small' color='dark-2' >{city}</Text>
                                    <Text size='small' color='dark-2' >{stateAbbrev}</Text>
                                  </Box>
                                </Box>
                              ))
                            }
                          </Box>
                        </Box>
                      </>
                    }
                  </Box>
                </>
              ) : null}
            </Box>
          </Layer>
        )}
      </ResponsiveContext.Consumer>
    );
  }
}

const mapStateToProps = ({ layerDetailsReducer, layerReducer }) => ({
  detail: layerDetailsReducer.detail,
  getDetailError: layerDetailsReducer.getDetailError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    toggleDetailsLayer,
  }, dispatch);

export const Details = connect(mapStateToProps, mapDispatchToProps)(DetailsAmendment);
